const adminActions = {
  login: (sessionData) => ({ type: "LOGIN", payload: sessionData }),
  logout: () => ({ type: "LOGOUT" }),
  unSetLoggedMessage: (sessionData) => ({
    type: "UNSET_LOGGED_MESSAGE",
    payload: sessionData,
  }),
};

export default adminActions;
